import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { ChevronRight, Eye } from 'lucide-react'
import { RootState, Task } from 'constants/interfaces'
import { isRtlSelector } from 'redux/selectors/general'
import { HubEntityItemWrapper } from 'components/helperStyles'
import { formatTimestamp } from 'utils'
import strings from 'constants/strings'
import colors from 'constants/colors'

interface IProps {
  task: Task
  onClick?: (task: Task) => void
}

export const OwnerTaskListItem: React.FC<IProps> = ({ task, onClick }) => {
  const { title, from_ts, to_ts, deadline, is_recurring, recurrence_ts, recurrence_deadline } = task
  const isUsDateFormat = useSelector((state: RootState) => state.general.theme?.is_support_us_date_format)
  const isRtl = useSelector(isRtlSelector)

  const startDate = is_recurring ? recurrence_ts : from_ts
  const endDate = is_recurring ? recurrence_deadline : deadline || to_ts

  const outputFormat = isUsDateFormat
    ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_US_FORMAT
    : strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT

  const fromFormatted = formatTimestamp(startDate, outputFormat, strings.DATE_FORMATS.inputs.taskPeriod)
  const toFormatted = formatTimestamp(endDate, outputFormat, strings.DATE_FORMATS.inputs.taskPeriod)

  const handleClick = () => {
    if (onClick) onClick(task)
  }

  return (
    <HubEntityItemWrapper onClick={handleClick} style={{ height: '60px', border: 'none', borderRadius: '10px' }}>
      <Flex alignItems="center" justifyContent="space-between" p="10px" height="100%" style={{ columnGap: '10px' }}>
        <Box flexShrink={0}>
          <Eye size={16} color={colors.greyMain} />
        </Box>
        <Flex flexDir="column" alignItems="flex-start" flex="1" minW={0}>
          <Text as="span" fontFamily="inherit" fontWeight="bold" fontSize="1rem" color={colors.blackLight} isTruncated>
            {title}
          </Text>
          <Text textAlign={isRtl ? 'right' : 'left'} dir="ltr" fontSize="11px" color={colors.greyMain}>
            {fromFormatted} - {toFormatted}
          </Text>
        </Flex>
        <Box flexShrink={0}>
          <ChevronRight size={20} color={colors.greyMain} style={{ transform: isRtl ? 'rotate(180deg)' : 'none' }} />
        </Box>
      </Flex>
    </HubEntityItemWrapper>
  )
}
